module.exports = __webpack_public_path__ + "img/infor1.c17d339a.png";